import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

/**
 * The app shell width, shared by `AppNav` and every app page so the nav and the
 * content below it line up. It steps up twice: a single fixed max width leaves a
 * phone-shaped column stranded in the middle of a desktop screen.
 */
export const SHELL_WIDTH = 'max-w-5xl lg:max-w-6xl xl:max-w-7xl'

const WIDTHS = {
  /** Dashboards, lists, tables — anything that gains from more columns. */
  shell: SHELL_WIDTH,
  /** Long-form pages, where measure matters more than filling the screen. */
  prose: 'max-w-4xl',
  /** Single-column editorial copy (about, auth). */
  narrow: 'max-w-2xl',
} as const

interface PageContainerProps {
  width?: keyof typeof WIDTHS
  className?: string
  children: ReactNode
}

export function PageContainer({ width = 'shell', className, children }: PageContainerProps) {
  return (
    <div className={cn('w-full mx-auto px-4 sm:px-6 lg:px-8', WIDTHS[width], className)}>
      {children}
    </div>
  )
}
